import React from 'react';
import styled from 'styled-components';
import { withHandlers } from 'recompose';
import PropTypes from 'prop-types';
import { COLOR_WHITE } from '../../constants/colors';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const CheckboxToggle = styled.div`
  border-radius: 2px;
  min-width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  background: #c4c4c4;
  justify-content: center;
  outline: none;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 2px;
    height: 10px;
    background: ${COLOR_WHITE};
    border-radius: 1px;
    left: 4px;
    top: 2px;
  }
`;

const CheckboxToggleActive = styled.div`
  border-radius: 2px;
  min-width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  background: #109cf1;
  justify-content: center;
  outline: none;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 2px;
    height: 10px;
    background: ${COLOR_WHITE};
    border-radius: 1px;
    left: 4px;
    top: 2px;
  }
`;

const Content = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  margin-left: 14px;
  color: #90a0b7;
`;

const CheckBoxToggle = ({ children, onChange, onKeyPress, checked }) => (
  <Wrapper onClick={onChange}>
    <CheckboxToggle tabIndex={0} onKeyPress={onKeyPress}>
      {checked && <CheckboxToggleActive />}
    </CheckboxToggle>
    {!checked && <Content>{children}</Content>}
  </Wrapper>
);

CheckBoxToggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]).isRequired,
};

CheckBoxToggle.defaultProps = {
  checked: false,
  onChange: () => {},
};

const enhance = withHandlers(() => ({
  onKeyPress: ({ onChange }) => e => {
    if (e.charCode === 13 || e.keyCode === 13) {
      onChange();
    }
  },
}));

export default enhance(CheckBoxToggle);
